import styled from "styled-components";
import { Heading } from "@pepdirect/v3/ui/Heading";
import { Alert } from "@pepdirect/v3/ui/Alert";
import { Device } from "@pepdirect/v3/styles/screenSizes";

export const StyledAddButton = styled.div`
  margin-bottom: 40px;
  span {
    margin-left: 8px;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-top: 40px;
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
`;

export const StyledSavedAddresses = styled.div`
  margin-bottom: 16px;
`;

export const StyledAdditionalPhoneNumber = styled.div`
  max-width: 420px;
  margin-top: 28px;
`;

export const StyledCouponCta = styled.div`
  margin-bottom: 20px;
  @media ${Device.notMobile} {
    display: none;
  }
`;
